import {UIGameFeed} from './UIGameFeed'

export class UIGameLogView extends UIGameFeed {
    constructor() {
        super('game-log-text', 'game-chat-block')
    }
}
